import { Pack, PackType, Repack, RepackSubType } from 'types/generated/graphql';
import { RoutePaths, QueryParams } from 'types/enums';
import { getPartOfCurrentQueryString } from './getPartOfCurrentQueryString';

export function getPackRouteEntityPath(item: Pack | Repack): RoutePaths {
    if (
        item.type === PackType.Repack &&
        (item as Repack).subType === RepackSubType.Chart
    ) {
        return RoutePaths.Charts;
    }

    if (item.type === PackType.Repack) {
        return RoutePaths.Collections;
    }

    return RoutePaths.Packs;
}

export function getPackLinkPath(item: Pack | Repack): string {
    const entityPath = getPackRouteEntityPath(item as Pack | Repack);

    // There's always only 1 tab on pack/repack details page - samples
    // so, to avoid errors when coming from `?tab=Pack`
    // we remove the tab query param
    const queryString = `?${getPartOfCurrentQueryString({
        routerQueryString: window.location.search,
        queriesToExclude: [QueryParams.tab, QueryParams.page],
    })}`;

    return `/${entityPath}/${item.slug}${queryString}`;
}
